module.exports = __webpack_public_path__ + "static/media/light.593b5776.webp";